import { defineMessages } from 'react-intl';

export const searchRecordGraphType = defineMessages({
  'dt:search_record_graph_type:bar': {
    id: 'search_record_graph_type.Bar.title',
    defaultMessage: 'Bar',
    value: 'bar',
  },
  'dt:search_record_graph_type:line': {
    id: 'search_record_graph_type.line.title',
    defaultMessage: 'Line',
    value: 'line',
  },
  'dt:search_record_graph_type:pie': {
    id: 'search_record_graph_type.pie.title',
    defaultMessage: 'Pie',
    value: 'pie',
  },
});
